export default "__VITE_ASSET__34539130__"